export default __webpack_public_path__ + "static/media/blue1.a416476f.svg";